import { BodyBold } from '../Typography';
import { Box, Link as MUILink, styled } from '@mui/material';
import { fontWeight } from '../../theme/typography';
import { HFlex } from '../FlexContainers';
import { palette } from '../../theme/palette';

export const Root = styled(HFlex, {
  shouldForwardProp: (prop) => prop !== 'useContainer',
})<{
  useContainer?: boolean;
}>`
  align-items: center;
  gap: 10px;
  min-height: ${(props) => (props.useContainer ? '72px' : '0px')};
  padding: ${(props) => (props.useContainer ? '10px 39px' : '0px')};
  border: ${(props) => (props.useContainer ? `1px solid ${palette.collection.grey.d250}` : 'none')};
  border-radius: 5px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    align-items: flex-start;
    padding: ${(props) => (props.useContainer ? '23px 39px' : '0px')};
    gap: 21px;
  }
`;

export const ContentWrapper = styled(HFlex)`
  gap: 4px;
  flex-wrap: wrap;
`;

export const Content = styled(BodyBold)`
  line-height: 21px;
  margin-bottom: 0px;
`;

export const Link = styled(MUILink)`
  color: ${palette.primary.main};
  font-size: 14px;
  font-weight: ${fontWeight.bold};
  line-height: 21px;
  letter-spacing: 0.35px;
  text-decoration-line: underline;
  cursor: pointer;
  white-space: nowrap;
`;

export const Separator = styled(HFlex)`
  flex: 1;
  max-width: 118px;
  min-width: 40px;
  justify-content: center;

  ${(props) => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const SeparatorLine = styled(Box)`
  width: 0px;
  border-right: 1px solid ${palette.collection.grey.d250};
  height: 35px;
  padding-left: 4px;
`;
